module.exports = __webpack_public_path__ + "static/media/girl-smiling.bc0b2704.png";